// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1366611b] .section-table{display:grid;border:1px solid #e6e6e6;border-radius:10px;overflow:hidden}[data-v-1366611b] .section-table.pax-table-template-columns{grid-template-columns:6% 44% 50%}[data-v-1366611b] .section-table .border-t{border-top:1px solid #e6e6e6}", ""]);
// Exports
module.exports = exports;
